import { useMemo, useState } from "react"
import { selectEffectiveCompanyId, selectEffectiveServiceCenterId } from "../../../../modules/context/contextSelectors"
import { useAppSelector } from "../../../../modules/store/storeHooks"
import { UserType } from "../../../../modules/login/loginTypes"
import { OrderOnBehalfDialog } from "./OrderOnBehalfDialog"
import { defaultUserDetailsState } from "../defaults"

export type UserDetailsProps = Readonly<{
    companyId?: string
    companyGroupId?: string
    selectedUserId?: number
    selectedUserName?: string
}>

type OrderOnBehalfFlowProps = Readonly<{
    onComplete: (id: number, name: string, companyId: number) => void
    handleCloseParentDialog: () => void
    userType?: UserType
}>

export function OrderOnBehalfFlow({ onComplete, userType, handleCloseParentDialog }: OrderOnBehalfFlowProps) {
    const companyId = useAppSelector(selectEffectiveCompanyId)
    const serviceCenterId = useAppSelector(selectEffectiveServiceCenterId)

    const [userDetailsState, setUserDetailsState] = useState<UserDetailsProps>(defaultUserDetailsState)
    const [openDialog, setOpenDialog] = useState(userType !== UserType.USER)

    const userId = useMemo(() => {
        switch (userType) {
            case UserType.MERCHANT:
            case UserType.COMPANY:
                return companyId
            case UserType.SERVICE_CENTER:
                return serviceCenterId
            default:
                return undefined
        }
    }, [userType, companyId, serviceCenterId])

    const handleUserSelectionComplete = () => {
        setOpenDialog(false)
        userDetailsState.selectedUserId &&
            userDetailsState.selectedUserName &&
            userDetailsState.companyId &&
            onComplete(userDetailsState.selectedUserId, userDetailsState.selectedUserName, +userDetailsState.companyId)
    }

    if (!userId || userType === UserType.USER) return <></>

    return (
        <>
            {userId &&
                (userType === UserType.MERCHANT ||
                    userType === UserType.SERVICE_CENTER ||
                    userType === UserType.COMPANY) && (
                    <OrderOnBehalfDialog
                        open={openDialog}
                        onClose={handleCloseParentDialog}
                        userId={userId}
                        userType={userType}
                        handleConfirmSelection={handleUserSelectionComplete}
                        userDetailsState={userDetailsState}
                        setUserDetailsState={setUserDetailsState}
                    />
                )}
        </>
    )
}
